"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Card = _interopRequireDefault(require("../../Card"));

var _useStyles = _interopRequireDefault(require("./useStyles"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/** Internal Drawer of the SlideableDrawer */


var Drawer = function Drawer(props, ref) {
  var _props$position = props.position,
      position = _props$position === void 0 ? 'bottom' : _props$position,
      color = props.color,
      elevation = props.elevation,
      borderColor = props.borderColor,
      other = (0, _objectWithoutProperties2["default"])(props, ["position", "color", "elevation", "borderColor"]);
  var classes = (0, _useStyles["default"])(color, borderColor, elevation);
  return (0, _core.jsx)(_Card["default"], (0, _extends2["default"])({
    ref: ref,
    css: /*#__PURE__*/(0, _css2["default"])([classes.root, classes[position]], ";label:Drawer;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TbGlkZWFibGVEcmF3ZXIvRHJhd2VyL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQnlCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9TbGlkZWFibGVEcmF3ZXIvRHJhd2VyL2luZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmLCBIVE1MUHJvcHMsIFJlZkZvcndhcmRpbmdDb21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBDYXJkIGZyb20gJy4uLy4uL0NhcmQnO1xuaW1wb3J0IHsgQ29sb3IsIERpcmVjdGlvbiwgRWxldmF0aW9uIH0gZnJvbSAnLi4vLi4vc3R5bGVzL3RoZW1lJztcbmltcG9ydCB1c2VTdHlsZXMgZnJvbSAnLi91c2VTdHlsZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIERyYXdlclByb3BzIGV4dGVuZHMgSFRNTFByb3BzPEhUTUxEaXZFbGVtZW50PiB7XG4gIC8qKiBUaGUgcG9zaXRpb24gb2YgdGhlIERyYXdlciAqL1xuICBwb3NpdGlvbj86IERpcmVjdGlvbjtcbiAgLyoqIENvbG9yIG9mIHRoZSB1bmRlcmx5aW5nIENhcmQgKi9cbiAgY29sb3I/OiBDb2xvcjtcbiAgLyoqIEVsZXZhdGlvbiBvZiB0aGUgdW5kZXJseWluZyBDYXJkICovXG4gIGVsZXZhdGlvbj86IEVsZXZhdGlvbjtcbiAgLyoqIEJvcmRlciBjb2xvciBvZiB0aGUgdW5kZXJseWluZyBDYXJkICovXG4gIGJvcmRlckNvbG9yPzogQ29sb3I7XG59XG5cbi8qKiBJbnRlcm5hbCBEcmF3ZXIgb2YgdGhlIFNsaWRlYWJsZURyYXdlciAqL1xuY29uc3QgRHJhd2VyOiBSZWZGb3J3YXJkaW5nQ29tcG9uZW50PEhUTUxEaXZFbGVtZW50LCBEcmF3ZXJQcm9wcz4gPSAocHJvcHMsIHJlZikgPT4ge1xuICBjb25zdCB7IHBvc2l0aW9uID0gJ2JvdHRvbScsIGNvbG9yLCBlbGV2YXRpb24sIGJvcmRlckNvbG9yLCAuLi5vdGhlciB9ID0gcHJvcHM7XG4gIGNvbnN0IGNsYXNzZXMgPSB1c2VTdHlsZXMoY29sb3IsIGJvcmRlckNvbG9yLCBlbGV2YXRpb24pO1xuXG4gIHJldHVybiA8Q2FyZCByZWY9e3JlZn0gY3NzPXtbY2xhc3Nlcy5yb290LCBjbGFzc2VzW3Bvc2l0aW9uXV19IGNvbG9yPXtjb2xvcn0gey4uLm90aGVyfSAvPjtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoRHJhd2VyKTtcbiJdfQ== */")),
    color: color
  }, other));
};

__signature__(Drawer, "useStyles{classes}", function () {
  return [_useStyles["default"]];
});

var _default = (0, _react.forwardRef)(Drawer);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Drawer, "Drawer", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/Drawer/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/Drawer/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();